<!-- Normal Map View -->
<div class="map-container" *ngIf="!isFullScreen">
    <div class="map-header">
        <h3 class="map-title">{{ mapTitle }}</h3>
        <button *ngIf="showFullscreenButton" class="header-icon-btn" (click)="toggleFullScreen()"
            title="Expand to fullscreen">
            <i class="fas fa-expand"></i>
        </button>
    </div>
    <div class="map-content">
        <div id="commonMapContainer"></div>
    </div>
</div>

<!-- Fullscreen Map View Modal -->
<div class="map-fullscreen-overlay" *ngIf="isFullScreen">
    <div class="map-fullscreen-header">
        <h2>{{ mapTitle }}</h2>
        <button class="fullscreen-close-btn" (click)="exitFullScreen()" title="Exit fullscreen">
            <i class="fas fa-compress"></i>
        </button>
    </div>
    <div class="map-fullscreen-content">
        <div id="commonMapFullscreenContainer"></div>
    </div>
</div>